//npm packages
import React, { memo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

//redux actions
import { userList } from '../../redux/actions';

//elements starts with capital letter
import { GridBase } from '../../components';

//helper files
import strings from '../../globalization';
import consts from '../../consts';

const User = memo(props => {
  const loginData = useSelector(state => {
    const { userDetail } = state.loginData.data || {};
    return userDetail;
  }, shallowEqual);
  const showHideAddButton =
    loginData && consts.UserRoleId.SuperAdmin.includes(loginData.UserRole);

  const columns = [
    { key: 'UserName', name: strings.UserName, width: 150 },
    { key: 'FirstName', name: strings.FirstName, width: 150 },
    { key: 'LastName', name: strings.LastName, width: 150 },
    { key: 'Email', name: strings.Email, width: 250 },
    { key: 'Tries', name: strings.Tries, width: 200, type: 'number' },
    {
      key: 'UserRole',
      name: strings.UserRole,
      width: 150,
      mode: 'remote',
      store: 'Role',
      valueProp: '_id',
      displayValue: 'DisplayValue'
    },
    {
      key: 'createdAt',
      name: strings.CreatedOn,
      type: 'date',
      hidden: true,
      width: 150
    }
  ];
  return (
    <GridBase
      {...props}
      columns={columns}
      action={userList}
      title={strings.ManageUser}
      comboType={['Role']}
      showAddButton={showHideAddButton}
      dataProperty="userListData"
      parentRoute="usermanagement"
      loadPref={true}
      listId="User"
    />
  );
});

export default User;
